import React from 'react';
import { Table, Space, Input, Select, Tooltip } from 'antd';
import { EyeOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { useRecoilValue } from 'recoil';
import { getPage } from 'hooks/useUser';
import Button from 'components/button';
import { DeleteIcon, EditIcon } from 'icons';

const { Search } = Input;

const ServicesList = ({
  services,
  loading,
  total,
  currentPage,
  pageSize,
  filters,
  filterData,
  onFiltersChange,
  onPageChange,
  refetch,
  deleteService,
}) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const pages = useRecoilValue(getPage);

  const columns = [
    {
      title: 'ID',
      dataIndex: 'id',
      key: 'id',
      width: 80,
    },
    {
      title: t('Titolo'),
      dataIndex: 'title',
      key: 'title',
    },
    {
      title: t('Descrizione'),
      dataIndex: 'description',
      key: 'description',
      ellipsis: true,
    },
    {
      title: t('Outlet Village'),
      dataIndex: 'shopping_center_title',
      key: 'shopping_center',
    },

    {
      title: t('Reservation required'),
      dataIndex: 'reservation_required',
      key: 'reservation_required',
      render: (value) => (value ? t('Yes') : t('No')),
    },
    {
      title: t('Azione'),
      key: 'action',
      width: 180,
      render: (_, record) => (
        <Space>
          {(pages?.ability?.can_read !== false ||
            record.can_read !== false) && (
            <Tooltip title={t('Visualizza')}>
              <Button
                type='secondary'
                icon={<EyeOutlined />}
                onClick={(e) => {
                  e.stopPropagation();
                  navigate(`${record.id}`);
                }}
                size='small'
              />
            </Tooltip>
          )}
          {record.can_update !== false && (
            <Tooltip title={t('Modifica')}>
              <Button
                type='secondary'
                icon={<EditIcon />}
                onClick={(e) => {
                  e.stopPropagation();
                  navigate(`${record.id}/edit`);
                }}
                size='small'
              />
            </Tooltip>
          )}
          {record.can_destroy !== false && (
            <Tooltip title={t('Elimina')}>
              <Button
                type='red'
                icon={<DeleteIcon />}
                onClick={(e) => {
                  e.stopPropagation();
                  deleteService(record.id);
                }}
                size='small'
              />
            </Tooltip>
          )}
        </Space>
      ),
    },
  ];

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        minHeight: 'calc(100vh - 180px)',
        padding: '0 24px',
      }}
    >
      <Space style={{ marginBottom: 16 }}>
        <Search
          placeholder={t('Cerca per titolo')}
          value={filters.by_title}
          onChange={(e) => onFiltersChange({ by_title: e.target.value })}
          style={{ width: 200 }}
        />
        <Select
          allowClear
          placeholder={t('Filtra per shopping center')}
          value={filters.by_shopping_center}
          onChange={(value) => onFiltersChange({ by_shopping_center: value })}
          style={{ width: 200 }}
        >
          {filterData.shopping_centers.map((sc) => (
            <Select.Option key={sc.value} value={sc.value}>
              {sc.title}
            </Select.Option>
          ))}
        </Select>
        {/* <Select
          allowClear
          placeholder={t('Filtra per chain')}
          value={filters.by_chain}
          onChange={(value) => onFiltersChange({ by_chain: value })}
          style={{ width: 200 }}
        >
          {filterData.chains.map(chain => (
            <Select.Option key={chain.value} value={chain.value}>
              {chain.title}
            </Select.Option>
          ))}
        </Select> */}
        {/* <Select
          allowClear
          placeholder={t('Filtra per reservation')}
          value={filters.by_reservation_required}
          onChange={(value) => onFiltersChange({ by_reservation_required: value })}
          style={{ width: 200 }}
        >
          <Select.Option value='true'>{t('Yes')}</Select.Option>
          <Select.Option value='false'>{t('No')}</Select.Option>
        </Select> */}

        <Button
          onClick={() => onFiltersChange({})}
          iconMargin={true}
          type={'red'}
          icon={<DeleteIcon />}
        >
          {t('Cancella i filtri')}
        </Button>
      </Space>

      <Table
        columns={columns}
        dataSource={services}
        loading={loading}
        rowKey='id'
        style={{ flex: 1 }}
        onRow={(record) => ({
          onClick: () => {
            if (record?.id) {
              navigate(`${record.id}`);
            }
          },
          style: { cursor: 'pointer' },
        })}
        pagination={{
          current: currentPage,
          pageSize: pageSize,
          total: total,
          onChange: onPageChange,
          showSizeChanger: true,
          style: { marginTop: 16 },
        }}
      />
    </div>
  );
};

export default ServicesList;
